// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-2817B770-43C6-4A6C-AB89-B45041E4337D .ltr {\n  direction: ltr;\n}\n", "",{"version":3,"sources":["webpack://src/security/userSessionLogs/userSessionLogs.less"],"names":[],"mappings":"AAAA;EAEQ,cAAA;AAAR","sourcesContent":["#V-2817B770-43C6-4A6C-AB89-B45041E4337D{\n    .ltr{\n        direction: ltr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
